const carouselItems = [
  {
    title: '诺兰导演电影回顾展',
    desc: '从《记忆碎片》到《奥本海默》，重温十部改变电影叙事方式的经典之作，深度解析诺兰式非线性叙事魅力。',
    tag: '导演专题',
    img: 'https://readdy.ai/api/search-image?query=Christopher%20Nolan%20film%20collage%20aesthetic%20with%20dark%20dramatic%20lighting%2C%20geometric%20patterns%2C%20time%20concept%20visual%2C%20cinematic%20blue%20and%20amber%20tones%2C%20sophisticated%20director%20tribute%20style%2C%20film%20cell%20texture%2C%20intellectual%20cinema%20mood&width=800&height=500&seq=carousel-07&orientation=landscape',
  },
  {
    title: '韩国犯罪悬疑片精选',
    desc: '从《杀人回忆》到《寄生虫》，盘点韩国电影工业最具代表性的十部犯罪悬疑力作，每一部都是影迷必看。',
    tag: '类型精选',
    img: 'https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20movie%20aesthetic%20with%20moody%20atmosphere%2C%20rainy%20urban%20night%20scene%2C%20neon%20signs%20reflection%2C%20dark%20alley%20cinematography%2C%20suspenseful%20tone%2C%20film%20noir%20inspired%20composition&width=800&height=500&seq=carousel-08&orientation=landscape',
  },
  {
    title: '暑期亲子观影指南',
    desc: '精心挑选适合全家一起观看的十部动画电影与冒险大片，涵盖迪士尼经典、皮克斯佳作与国产动画新势力。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20film%20collage%20with%20warm%20summer%20vibe%2C%20soft%20golden%20sunset%20lighting%2C%20playful%20and%20family%20friendly%20atmosphere%2C%20animation%20art%20style%20blend%2C%20cheerful%20and%20bright%20composition%2C%20cinematic%20quality&width=800&height=500&seq=carousel-09&orientation=landscape',
  },
  {
    title: '豆瓣高分华语电影合集',
    desc: '收录近十年豆瓣评分 8.0 以上的华语佳作，从《我不是药神》到《流浪地球》，见证华语电影的崛起之路。',
    tag: '高分合集',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20artistic%20composition%20with%20dramatic%20contrast%20lighting%2C%20modern%20Asian%20film%20aesthetic%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20elegant%20minimalist%20design%20elements%2C%20sophisticated%20movie%20tribute%20mood&width=800&height=500&seq=carousel-10&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            精选专题
          </h2>
        </div>

        {/* All cards visible, no carousel behavior */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer">
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-foreground-900 font-heading text-sm md:text-base font-bold mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}